import { createAuthenticator } from 'redux-simple-auth'
import { revoke, isValid } from 'utils/token'

export default createAuthenticator({
  name: 'oauth2-password-grant',
  restore: data => (isValid(data) ? Promise.resolve(data) : Promise.reject()),
  authenticate: async ({ email, password }) => {
    const data = {
      grant_type: 'password',
      username: email,
      password
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_HOST}/oauth/token`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: Object.keys(data)
          .map(
            key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
          )
          .join('&')
      }
    )

    const json = await response.json()

    if (!response.ok) {
      return Promise.reject(json)
    }

    return json
  },

  invalidate: ({ access_token }) => revoke(access_token)
})



// WEBPACK FOOTER //
// ./src/authenticators/oauth2PasswordGrant.js